import { Divider, Form, Header } from 'semantic-ui-react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { PerformanceReportConfigurationCreate } from './edit/PerformanceReportConfigurationCreate'
import { PerformanceReportConfigurationUpdate } from './edit/PerformanceReportConfigurationUpdate'
import useUser from '../Shared/UserProvider/useUser'
import { getPerformanceReportConfigurations } from '../../services/Provider/Provider.service'
import { PerformanceReportConfigurationPlaceholder } from './PerformanceReportConfigurationPlaceholder'
import { PerformanceReportConfigurationHeader } from './PerformanceReportConfigurationHeader'
import { useTranslation } from 'react-i18next'
import AdvancedFilters from '../Home/AdvancedFilters'
import { getPointOfSale } from '../../services/PointOfSale/PointOfSale.service'
import { useSearchParams } from 'react-router-dom-v5-compat'

const PerformanceReportConfigurationList = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const queryClient = useQueryClient()
    const [searchParams, setSearchParams] = useSearchParams()

    const selectedPosId = searchParams.get('posId')

    const {data: selectedPos} = useQuery({
        queryKey: ['pointofsales', selectedPosId],
        queryFn: () => getPointOfSale(selectedPosId),
        enabled: !!selectedPosId,
    })

    const handleSelectedPosChange = (filters) => {
        queryClient.setQueryData(['pointofsales', filters.merchantId], filters.merchantId)
        const params = new URLSearchParams()
        params.append('posId', filters.merchantId)
        setSearchParams(params)
    }

    const {data: performanceReportConfigurations, isLoading} = useQuery({
        queryKey: ['providers', user.isLoggedInOwnScope ? selectedPos?.providerId : user.provider.id, 'performanceReportConfigurations'],
        queryFn: () => getPerformanceReportConfigurations(user.isLoggedInOwnScope ? selectedPos?.providerId : user.provider.id),
        enabled: user.isLoggedInOwnScope ? !!selectedPos?.providerId : !!user.provider.id,
    })

    return (
      <>
          {user.isLoggedInOwnScope &&
            <Form>
                <AdvancedFilters
                  filters={{
                      merchantId: selectedPosId || user.loginContext.providers[0]?.object.id,
                  }}
                  debounceTimeInMs={0}
                  onFiltersChange={handleSelectedPosChange}
                >
                    <AdvancedFilters.PosFilter/>
                </AdvancedFilters>
                <Divider/>
            </Form>
          }

          <PerformanceReportConfigurationHeader />

          <PerformanceReportConfigurationCreate />

          {performanceReportConfigurations?.length > 0 && <Header>{t('reports.performance_configuration.your_reports')}</Header>}

          {isLoading && <PerformanceReportConfigurationPlaceholder />}

          {performanceReportConfigurations?.length > 0 && performanceReportConfigurations.map(performanceReportConfiguration => (
              <PerformanceReportConfigurationUpdate
                key={performanceReportConfiguration.id}
                performanceReportConfiguration={performanceReportConfiguration}
              />
            ))
          }
      </>
    )
}

export { PerformanceReportConfigurationList }
